module.exports = __webpack_public_path__ + "img/undraw_login_blue.c64b4040.svg";